import { useEffect, useRef } from 'react';

export const NumberwithComma = (item: number | string) => {
  const num = Number(item);
  if (item === null || item === undefined || isNaN(num)) {
    return '업데이트 준비중';
  }
  return num.toFixed(1).toLocaleString();
};

export const ReportFormatNumber = (
  item: number | string | null | undefined,
  percent?: boolean,
  showUnit: boolean = true,
  reduction?: boolean, // 감면율용 플래그
) => {
  if (item === null || item === undefined) return '-';

  const num = Number(item);
  if (isNaN(num)) return '-';

  if (percent) {
    return num.toFixed(1) + (showUnit ? ' %' : '');
  } else if (!percent && num) {
    return num.toLocaleString() + (showUnit ? ' 원' : '');
  } else {
    return '-';
  }
};

export const useDidMountEffect = (func: any, deps: any) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};

export const formatCurrency = (value: number | null | undefined) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '업데이트 준비중';
  }

  if (value >= 1000_0000) {
    return (value / 1_0000_0000).toFixed(1).toLocaleString() + '억원';
  } else if (value >= 1_0000) {
    return (value / 1_0000).toFixed(0).toLocaleString() + '만원';
  } else {
    return value.toLocaleString() + '원';
  }
};

export const formatToEokMan = (value: any) => {
  if (value === null || value === undefined) return '-';
  // if (value === null || value === undefined) return '업데이트 준비중';

  if (typeof value !== 'number') {
    value = Number(value);
  }
  if (isNaN(value)) return '-';
  // if (isNaN(value)) return '업데이트 준비중';

  if (value < 10000) {
    return value.toLocaleString() + '원';
  }

  const eok = Math.floor(value / 100000000);
  const man = Math.round((value % 100000000) / 10000);

  let result = '';

  if (eok > 0) {
    result += `${eok.toLocaleString()}억 `;
  }

  if (man > 0) {
    result += `${man.toLocaleString()}만원`;
  }

  return result.trim();
};

export const utilTransNum = (num: number | null | undefined) => {
  if (num === null || num === undefined) return '업데이트 준비중';

  num = Number(num);
  if (isNaN(num)) return '업데이트 준비중';

  if (num === 0) return '업데이트 준비중';
  else if (num < 10000) {
    return Math.round(num).toLocaleString();
  } else if (num < 100000000) {
    return Math.round(num / 10000).toLocaleString() + '만';
  } else if (num < 1000000000000) {
    const value = num / 100000000;
    return Number(value.toFixed(1)).toLocaleString() + '억';
  } else {
    const value = num / 1000000000000;
    return Number(value.toFixed(1)).toLocaleString() + '조';
  }
};
